import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import FaqAccordion from "@/components/feature/FaqAccordion";
import SubscribeForm from "@/components/feature/SubscribeForm";
import { useSeo } from "@/hooks/useSeo";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import Featured from "./components/Featured";
import Editorial from "./components/Editorial";

const BASE = "https://secretcomix.github.io";

export default function Home() {
  useSeo({
    title: "喵趣漫画网 - 萌系日常与治愈番合集，搞笑萌漫、软萌画风轻松追更",
    description:
      "喵趣漫画网萌系日常频道，收录治愈番、搞笑萌漫、软萌画风、温馨向轻喜剧等轻松作品。不用费脑，点开就开心，适合碎片时间放松，热门萌系日常一网打尽。",
    keywords: "喵趣漫画网,萌系日常,治愈番,搞笑萌漫,软萌画风,温馨向,轻喜剧",
    url: BASE + "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "喵趣漫画网",
        url: BASE + "/",
        description: "萌系日常与治愈番合集，收录治愈番、搞笑萌漫、软萌画风、温馨向轻喜剧等轻松作品。",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "喵趣漫画网",
        url: BASE + "/",
        logo: BASE + "/favicon.svg",
        sameAs: [],
      },
    ],
  });

  return (
    <Layout>
      <Hero />
      <CategoryGrid />
      <Featured />
      <Editorial />

      <section className="container-page mt-12 md:mt-16">
        <div className="flex items-end justify-between">
          <div>
            <span className="chip bg-secondary-100 text-secondary-900">
              <i className="ri-question-line mr-1" aria-hidden="true"></i>
              常见问题
            </span>
            <h2 className="mt-3 text-xl font-bold text-foreground-950 md:text-2xl">追更前，你可能想知道</h2>
          </div>
          <Link to="/faq" className="hidden items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800 sm:flex">
            查看全部 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
        <div className="mt-6">
          <FaqAccordion limit={4} />
        </div>
      </section>

      <section className="mt-12 md:mt-16">
        <div className="container-page rounded-3xl bg-gradient-to-br from-primary-500 to-primary-600 px-6 py-12 text-center text-background-50 md:py-14">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/20 px-4 py-1.5 text-xs font-bold">
            <i className="ri-mail-send-line text-sm" aria-hidden="true"></i>
            喵趣每周精选
          </span>
          <h2 className="mt-5 text-2xl font-bold md:text-3xl">不想错过每一部治愈之作？</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-background-100/90 md:text-base">
            订阅喵趣漫画网频道，每周为你精选一部值得收藏的萌系日常作品，把碎片时间留给真正好看的内容。
          </p>
          <div className="mt-7">
            <SubscribeForm />
          </div>
        </div>
      </section>
    </Layout>
  );
}